import { ElkServiceBase, WsElk } from "./wsdl/ws_elk/v1/ws_elk.ts";

export {
    type WsElk
};

export class ElkService extends ElkServiceBase {
}
